import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { ImageCardsFragment } from '../types/graphqlTypes';
import { CardCarouselWrapper } from './CardCarouselWrapper';
import { Section } from './Section';
import { ImageCardRenderer } from './ImageCardRenderer';
import { Grid } from './Grid';
import Spacer from './Spacer';
import { Typography } from './Typography';

interface ImageCardsProps extends ImageCardsFragment {
  width: 'narrow' | 'wide';
}

export const ImageCards: FC<Omit<ImageCardsProps, '__typename'>> = ({
  title,
  lead,
  format,
  backgroundColour,
  imageCards,
  width,
  hideLearnMore,
}) => {
  if (imageCards.length < 1) {
    return null;
  }

  return (
    <Section
      contained
      background={backgroundColour ? backgroundColour.replace('1', '') : 'white'}
      narrow={width === 'narrow'}
      overflowHidden
    >
      {format === 'Carousel' && (
        <CardCarouselWrapper heading={title} lead={lead} width={width}>
          {imageCards.map((imageCard, index) => (
            <ImageCardRenderer {...imageCard} vertical key={`imc1-${index}`} />
          ))}
        </CardCarouselWrapper>
      )}
      {format !== 'Carousel' && (
        <Spacer responsive>
          {title || lead ? (
            <Spacer spacing="quarter">
              {title && (
                <Typography component="h2" variant="displaySmall">
                  {title}
                </Typography>
              )}
              {lead && (
                <Typography component="p" variant="lead">
                  {lead}
                </Typography>
              )}
            </Spacer>
          ) : (
            ''
          )}

          <Grid desktopColumns="2">
            {imageCards.map((imageCard, index) => (
              <ImageCardRenderer
                {...imageCard}
                hideLearnMore={hideLearnMore}
                vertical={width === 'narrow'}
                key={`imc2-${index}`}
              />
            ))}
          </Grid>
        </Spacer>
      )}
    </Section>
  );
};
